import { ReactNode } from 'react';
import { HStack, VStack } from '@chakra-ui/react';
import { AppTheme } from '../../theming/valuobject/app-theme.ts';
import PageHeader from '../heading/page-header.tsx';
import PageFooter from './page-footer.tsx';
import useMediaViewModel from '../../../app/domain/common/view-model/media-view-model.ts';

interface PageLayoutProps {
  title: string;
  children?: ReactNode;
}

/**
 * A component that defines the base layout for an application. It sets the document title and
 * renders the provided children elements within a vertical stack layout.
 */
export default function PageLayout({ title, children }: PageLayoutProps) {
  const { isMobile } = useMediaViewModel();

  return (
    <VStack width={'100%'} minHeight={'100vh'} background={AppTheme.Color.gray}>
      <HStack as={'header'} width="100%">
        {/* muss im DOM enthalten sein, wird aber nicht gerendert */}
        <title>{title}</title>
        {/* Seiten-Header mit Logo & Language-Select */}
        <PageHeader />
      </HStack>
      <VStack
        as={'main'}
        flex={1}
        alignItems="center"
        width={'100%'}
        maxWidth={AppTheme.Constant.MAX_APP_WIDTH}
        paddingX={{
          base: AppTheme.Size.PX_16,
          md: AppTheme.Size.PX_32,
          lg: AppTheme.Size.PX_32,
          xl: AppTheme.Size.PX_32,
        }}
        paddingY={isMobile ? AppTheme.Size.PX_4 : AppTheme.Size.PX_32}
        gap={{
          base: AppTheme.Size.PX_16,
          md: AppTheme.Size.PX_36,
        }}
      >
        {children}
      </VStack>
      <PageFooter />
    </VStack>
  );
}
